import React, { useEffect, useState } from 'react';
import { Icon } from '@scuf/common';
import './Forbidden.scss';
import { useLocation } from 'react-router-dom';
import i18next from '../../i18next';
import { useAuthService } from '../../auth/hooks/useAuthService';

export const ForbiddenPage = () => {
  const { user, isLoading, signIn } = useAuthService();
  const location = useLocation();
  const reason = new URLSearchParams(location.search).get('reason');
  const isTechnicianExternal = reason === 'technicianExternal';

  const [userLoggedIn, setUserLoggedIn] = useState<boolean>(false);

  useEffect(() => {
    if (isLoading) return;
    
    setUserLoggedIn(!!user);
    if (!user) {
      signIn();
    }
  }, [user, isLoading, signIn]);
  return (
    <div className="forbidden-container">
      <div className="forbidden-page">
        {!userLoggedIn ? (
          <>
            {/* <Icon name="badge-warning" size="xlarge" /> */}
            <h1>{i18next.t('redirectToLogin')}...</h1>
          </>
        ) : (
          <>
            <Icon name="badge-warning" size="xlarge" />
            {isTechnicianExternal ? (
              <>
                <h1>{i18next.t('forbidden')}</h1>
                <p>{i18next.t('noPermissionText')}</p>
                <p>{i18next.t('technicianExternalAccessPermission')}</p>
              </>
            ) : (
              <>
                <h1>{i18next.t('forbidden')}</h1>
                <p>{i18next.t('noPermissionText')}</p>
                <p>{i18next.t('accessPermission')}</p>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ForbiddenPage;
